import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useAuth } from '../../contexts/AuthContext';
import Header from '../../components/navigation/Header';
import MobileNavigation from '../../components/navigation/MobileNavigation';
import AccountInfoTab from './components/AccountInfoTab';
import SubscriptionTab from './components/SubscriptionTab';
import DataManagementTab from './components/DataManagementTab';

const AccountSettings = () => {
  const { user, userProfile, loading } = useAuth();
  const [activeTab, setActiveTab] = useState('account');

  const tabs = [
    { id: 'account', label: 'Account Information', icon: 'User' },
    { id: 'subscription', label: 'Subscription & Billing', icon: 'CreditCard' },
    { id: 'data', label: 'Data Management', icon: 'Database' }
  ];

  if (loading) {
    return (
      <>
        <Helmet>
          <title>Account Settings - GalleyPlan</title>
        </Helmet>
        <Header />
        <div className="min-h-screen pt-16 flex items-center justify-center">
          <div className="text-center">
            <p className="text-lg text-muted-foreground">Loading settings...</p>
          </div>
        </div>
        <MobileNavigation />
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>Account Settings - GalleyPlan</title>
        <meta name="description" content="Manage your GalleyPlan account settings, subscription, and preferences" />
      </Helmet>
      <Header />
      <div className="min-h-screen pt-16 pb-20 md:pb-8">
        <div className="max-w-5xl mx-auto px-4 py-8">
          {/* Page Header */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold" style={{ color: 'var(--color-text-primary)' }}>
              Account Settings
            </h1>
            <p className="mt-2 text-muted-foreground">
              Manage your account preferences and subscription details
            </p>
          </div>

          {/* Tabs Navigation - Desktop */}
          <div className="hidden md:block mb-8">
            <div className="border-b" style={{ borderColor: 'var(--color-border)' }}>
              <nav className="flex space-x-8">
                {tabs?.map((tab) => (
                  <button
                    key={tab?.id}
                    onClick={() => setActiveTab(tab?.id)}
                    className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                      activeTab === tab?.id
                        ? 'border-primary text-primary' :'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
                    }`}
                  >
                    {tab?.label}
                  </button>
                ))}
              </nav>
            </div>
          </div>

          {/* Tabs Navigation - Mobile (Accordion Style) */}
          <div className="md:hidden mb-6">
            <div className="space-y-2">
              {tabs?.map((tab) => (
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`w-full text-left px-4 py-3 rounded-lg font-medium text-sm transition-colors ${
                    activeTab === tab?.id
                      ? 'bg-primary text-primary-foreground'
                      : 'bg-card text-foreground hover:bg-accent'
                  }`}
                  style={activeTab !== tab?.id ? { backgroundColor: 'var(--color-card)' } : {}}
                >
                  {tab?.label}
                </button>
              ))}
            </div>
          </div>

          {/* Tab Content */}
          <div className="rounded-lg p-6" style={{ backgroundColor: 'var(--color-card)' }}>
            {activeTab === 'account' && <AccountInfoTab user={user} userProfile={userProfile} />}
            {activeTab === 'subscription' && <SubscriptionTab user={user} userProfile={userProfile} />}
            {activeTab === 'data' && <DataManagementTab user={user} />}
          </div>
        </div>
      </div>
      <MobileNavigation />
    </>
  );
};

export default AccountSettings;